import jwt_decode, { JwtPayload } from 'jwt-decode';
import { StringConstants } from './constants';
import { default as UserHome } from 'app/pages/user/home/Home';
import { default as AdminHome } from 'app/pages/admin/home/Home';
import { IRoles } from 'app/models/common/post';
import { UserRole } from 'generated/request-backend';

const { ADMIN, SUPER_ADMIN, CONTENT_CREATOR, CONTENT_MANAGER, DO_NOT_DISTURB, BETA_USER, INTERNAL_DEV } = StringConstants;

// List of roles that are still considered "users" for access purposes
// If a user either has no roles or only these roles, they are treated as a regular user
const allowedUserRoles: string[] = [
    BETA_USER,
    INTERNAL_DEV
];

export const getAccessToken = () => {
    return localStorage.getItem('accessToken');
};
export const getPowerBiToken = () => {
    return localStorage.getItem('powerBIToken');
};

export const decodeToken = (token: string) => {
    const decodedToken: { roles: Array<string>; oid: string; email: string } = jwt_decode(token);
    return decodedToken;
};
export const getDecodedData = (token: string) => {
    const decodedToken: JwtPayload = jwt_decode(token);
    return decodedToken;
};
export const getRole = (token: string) => {
    const decodedToken = decodeToken(token);

    return decodedToken?.roles || [];
};

export const getRoles = (roles: IRoles[] | UserRole[] | string) => {
    let role = [];
    if (typeof roles === 'string') {
        const decodedToken = decodeToken(roles);
        role = decodedToken?.roles || [];
    } else {
        role = roles?.map((role) => role.roleName) || [];
    }
    // return role;
    return Array.from(role).filter((r) => r !== DO_NOT_DISTURB);
};

export const isLoggedIn = (token: string) => {
    return token ? true : false;
};

export const isAdmin = (roles: IRoles[] | UserRole[] | string) => {
    return getRoles(roles).includes(ADMIN);
};

export const isUser = (roles: UserRole[] | string) => {
    // A user is defined as someone who has either no roles or only roles that are in the allowedUserRoles list
    const userRoles = getRoles(roles).filter(role => !allowedUserRoles.includes(role));
    return userRoles.length === 0;
};

export const isSuperAdmin = (roles: IRoles[] | UserRole[] | string) => {
    return getRoles(roles).includes(SUPER_ADMIN);
};

export const isContentCreator = (roles: UserRole[] | string) => {
    return getRoles(roles).includes(CONTENT_CREATOR);
};

export const isContentManager = (roles: IRoles[] | UserRole[] | string) => {
    return getRoles(roles).includes(CONTENT_MANAGER);
};

export const isBetaUser = (roles: UserRole[] | string) => {
    return getRoles(roles).includes(BETA_USER);
};

export const isInternalDev = (roles: IRoles[] | string) => {
    return getRoles(roles).includes(INTERNAL_DEV);
};

export const getComponent = (roles: UserRole[] | string): React.FC => {
    if (isAdmin(roles) || isSuperAdmin(roles)) return AdminHome;
    return UserHome;
};

export const userPaths = [
    'knowledge-portal',
    'help-request',
    'request-help',
    'create-ticket',
    'add-customer',
    'unified-dashboard',
    'visual-flow',
    'request',
    'article',
    'news-feed',
    'portal-training',
    'submit-feedback',
    'unsubscribe',
    'all-articles',
    'all-news',
    StringConstants.KNOWLEDGE_ARTICLES
];
